import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getClassesByAssessmentId } from "../services/APIClient";
import HeadingBanner from "../components/HeadingBanner";
import LeftPanel from "../components/LeftPanel";
import SencoStudentsResultsOverview from "../components/SencoStudentResultsOverview";
import OrientationPrompt from "../components/OrientationPrompt";
import { Container, Row, Col } from "react-bootstrap";

function SencoStudentsResults(props) {
  const location = useLocation();
  
  // Extract state values with proper destructuring
  const {
    name,
    classDetails = {},
    allClassesAssessments,
    teachers = [],
    assessment = {},
    schoolid,
    teacherid,
    academicYear,
    classIds,
    assessmentId
  } = location.state || {};

  // Component state
  const [error, setError] = useState(null);
  const [classList, setClassList] = useState(null);
  const [showAtRiskOnly, setShowAtRiskOnly] = useState(false);
  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );

  // Handle orientation changes
  useEffect(() => {
    const mediaQuery = window.matchMedia("(orientation: portrait)");
    const handleOrientationChange = (e) => setIsPortrait(e.matches);
    
    mediaQuery.addEventListener("change", handleOrientationChange);
    return () => mediaQuery.removeEventListener("change", handleOrientationChange);
  }, []);

  // Fetch classes by assessment ID
  useEffect(() => {
    if (!assessmentId) {
      setError("Assessment ID is missing.");
      return;
    }

    const timeframe = academicYear ? {
      start: new Date(academicYear.start).toISOString(),
      end: new Date(academicYear.end).toISOString(),
    } : null;

    getClassesByAssessmentId(assessmentId, schoolid, timeframe)
      .then((response) => {
        setClassList(response);
        setError(null); // Clear any previous errors
      })
      .catch((err) => {
        console.error("Error fetching classes by assessment ID:", err);
        setError("Failed to load class data. Please try again.");
      });
  }, [assessmentId, schoolid, academicYear]);

  // Early return for missing required data
  if (!location.state) {
    return (
      <Container fluid className="vh-100">
        <div className="d-flex justify-content-center align-items-center h-100">
          <div className="text-center">
            <h3>No data available</h3>
            <p>Please navigate from the previous page.</p>
          </div>
        </div>
      </Container>
    );
  }

  return (
    <Container fluid className="vh-100">
      <HeadingBanner
        name={name?.name || name}
        isLoggedIn={true}
        cloud={true}
        teacherid={teacherid}
      />
      <Row className="h-100">
        <LeftPanel />
        <Col sm={{ span: 10, offset: 2 }} className="blue-background">
          <SencoStudentsResultsOverview
            key={assessmentId}
            classList={classList}
            gradeLevel={props.gradeLevel}
            teachers={teachers}
            assessment={assessment}
            assessmentId={assessmentId}
            schoolid={schoolid}
            teacherid={teacherid}
            name={name}
            allClassesAssessments={allClassesAssessments}
            showAtRiskOnly={showAtRiskOnly}
            setShowAtRiskOnly={setShowAtRiskOnly}
            classIds={classIds}
            academicYear={academicYear}
          />
        </Col>
      </Row>
      
      {isPortrait && <OrientationPrompt />}
      {error && (
        <div className="position-fixed top-0 start-50 translate-middle-x mt-3">
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        </div>
      )}
    </Container>
  );
}

export default SencoStudentsResults;
